import { ADOBE_LAUNCH_ACTIONS } from '../utils/constants/ActionTypes';
import { createMarketingData  as marketingDataService } from '../services/adobeLaunch';

export const createMarketingData = (data,id) => {
    return {
        type    : ADOBE_LAUNCH_ACTIONS.CREATE__MARKETING_ITEM,
        payload : marketingDataService(data,id)
    }
};
